import React from 'react';
import AssignInstrumentToChannel from '../../actions/AssignInstrumentToChannel'
import PropTypes from 'prop-types';
export default class InstrumentItem extends React.Component {
	static propTypes = {
		name: PropTypes.string
	};

	constructor(props) {
		super(props);
	}

	static contextTypes = {
		executeAction: PropTypes.func.isRequired
	};

	render() {
		return (
			<li className="instrument-item">
				{this.props.name}
				<div className="use" onClick={this.handleAssign.bind(this)}>Assign</div>
			</li>
		);
	}

	handleAssign() {
		this.context.executeAction(AssignInstrumentToChannel, { type: this.props.type });
	}
}
